export const regexWhatsappBrazil = /\+55[1-9]{2}(?:[2-8]|9[1-9])[0-9]{3}[0-9]{4}/;
